import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex-cen-ter productInfo" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { computed } from 'vue'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import ProductStats from '../../components/ProductStats.vue'
import { productStatsEnum } from '@/views/usercenter/Order/data'
import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  props: ['tableData', 'customerOperateType', 'type', 'long'],
  setup(__props) {

const props = __props


const columns = [
  {
    label: t('商品信息'),
    prop: 'productInfo',
    align: 'center',
    width: props.long ? 214 : 200,
    slotName: 'productInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    width: props.long ? 160 : 140
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center',
    width: props.long ? 120 : 90
  }
  // {
  //   label: t('商品状态'),
  //   prop: 'shoppingStats',
  //   align: 'center',
  //   width: 140,
  //   slotName: 'shoppingStats'
  // },
  // {
  //   label: t('选择结果'),
  //   prop: 'action',
  //   align: 'center',
  //   width: 170,
  //   slotName: 'action'
  // }
]

const onShowColums = computed(() => {
  if (props.type === 3) {
    return [...columns].concat([{
      label: t('选择结果'),
      prop: 'detail',
      align: 'center',
      width: props.long ? 445 : 170,
      slotName: 'action'
    }])
  } else {
    return [...columns].concat([
      {
        label: t('商品状态'),
        prop: 'shoppingStats',
        align: 'center',
        width: props.long ? 200 : 140,
        slotName: 'shoppingStats'
      },
      {
        label: t('选择结果'),
        prop: 'action',
        align: 'center',
        width: props.long ? 246 : 285,
        slotName: 'action'
      }
    ])
  }
})

const showDeal = (row:any) => {
  return row?.orderItemStatusList.map((v:any) => v.orderItemStatus).some((v:any) => [8, 9, 10, 12].includes(v)) || row?.orderType === 2 || row.cancelStatus === 4
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(STable, {
    ref: (_value, _refs) => {
      _refs['STableRef'] = _value
    },
    "show-pagination": false,
    "table-data": props.tableData,
    height: "300px",
    columns: _unref(onShowColums),
    class: "groupProTable"
  }, {
    productInfo: _withCtx(({ row }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ShoppingPreview, {
          image: row.productSkuImg || row.productMainImg || '',
          name: row.productTitleJp || ''
        }, null, 8, ["image", "name"])
      ])
    ]),
    shoppingStats: _withCtx(({ row }) => [
      row
        ? (_openBlock(), _createBlock(ProductStats, {
            key: 0,
            row: row,
            cancelJump: true,
            orderNo: row.platformOrderNo
          }, null, 8, ["row", "orderNo"]))
        : _createCommentVNode("", true)
    ]),
    action: _withCtx(({row}) => [
      (!showDeal(row) && __props.customerOperateType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (__props.customerOperateType === 18)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  modelValue: row.dealType,
                  "onUpdate:modelValue": ($event: any) => ((row.dealType) = $event),
                  style: {"width":"255px"},
                  disabled: __props.type === 3
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('继续发货'),
                      value: 1
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('取消发货转为库存'),
                      value: 2
                    }, null, 8, ["label"])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]))
              : (_openBlock(), _createBlock(_component_el_select, {
                  key: 1,
                  modelValue: __props.customerOperateType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(customerOperateType) ? (customerOperateType).value = $event : null)),
                  style: {"width":"255px"},
                  disabled: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('继续发货'),
                      value: 16
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('取消发货转为库存'),
                      value: 17
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, "-"))
    ]),
    detail: _withCtx(({row}) => [
      _createElementVNode("div", null, _toDisplayString(row.dealType === 1?_unref(t)('继续发货'):row.dealType === 2?_unref(t)('取消发货转为库存'):'-'), 1)
    ]),
    _: 1
  }, 8, ["table-data", "columns"]))
}
}

})